// extracted by mini-css-extract-plugin
module.exports = {"roleCard":"CrerCounslrs_roleCard__xNsiH"};